import { RecaptchaSettings } from 'ng-recaptcha';
import { environment } from '../../../../environments/environment';
const ɵ0 = {
    siteKey: environment.recaptchaSiteKeyClient,
};
export class RegisterModule {
}
export { ɵ0 };
